import React, { useState } from "react";
import "./style.scss";
import RevealAnimation from "../RevealAnimation";
import Button from "../Button";
import RightArrow from "./../../assets/Images/services/massage-chat.png";
import { Link } from "gatsby";
import { Tooltip } from "@material-ui/core";

function OurOffering({
  title = "Our Offerings",
  details = "We work with you to define your strategic vision, aligning your goals with tailored digital roadmaps, robust technical architecture and impactful planning to drive business transformation.",
  CardListData = [],
  pageName = "consult",
}) {
  return (
    <div className="service-offering-wrapper">
      <RevealAnimation
        component={"h2"}
        animation={"slide-left"}
        className="title-header mt-15 title-underline"
      >
        {title}
      </RevealAnimation>
      <div className="offer-content mt-30">
        <p className="offer-details-heading">{details}</p>
      </div>
      <div className="offer-list-items mt-70">
        <div className="expertise-items list-offer-card-items body-container">
          {CardListData?.map((item, idx) => (
            <div key={idx} className="card-item-wrapper">
              <div className="card-img-wrapper">
                {item?.image ? (
                  <img alt={item.label} src={item?.image} />
                ) : (
                  <img alt={item.label} src={RightArrow} />
                )}
              </div>
              <div className="card-content-wrapper">
                <div className="card-content-body">
                  {item?.path ? (
                    <Link to={item?.path} target="_self">
                      <h2>{item?.label}</h2>
                    </Link>
                  ) : (
                    <h2>{item?.label}</h2>
                  )}
                  <p>{item?.details}</p>
                </div>
                <div className="card-control-btnLink">
                  <Link
                    target="_self"
                    to={`/contact-us?type=${encodeURIComponent(
                      pageName
                    )}&name=${encodeURIComponent(item?.label)}`}
                  >
                    <Tooltip title={item?.buttonName} placement="bottom">
                      <Button
                        customClassName="service-offering-btn"
                        color="primary"
                        variant="text"
                        onClick={(e) => e.stopPropagation()}
                        label={"Ask an Expert"}
                        tip={item?.buttonName}
                        tooltip="no"
                      />
                    </Tooltip>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OurOffering;
